/**
 * DGA menu tracking, aanvullende events
 *
 * LET OP: dga_menu_click wordt al gepusht door assets/dga-mega-menu.js.
 * Dit bestand raakt dat event NIET aan, om dubbeltelling te voorkomen.
 * Het vult alleen de events aan die daar ontbreken en die de nulmeting nodig
 * heeft:
 *
 *   dga_menu_open               mobiel menu gaat open
 *   dga_menu_panel_open         subpaneel klapt open (mobiel en desktop)
 *   dga_menu_back               terugknop op mobiel  <- vervangt de Terug-proxy
 *   dga_search_open             zoekfunctie wordt geopend
 *   dga_search_suggestion_click klik op een zoeksuggestie
 *
 * Werkt op de bestaande markup van sections/dga-mega-menu.liquid, er zijn geen
 * wijzigingen aan het menu nodig. Roept bewust geen gtag() aan: GA4 loopt via
 * GTM, een directe call zou dubbel tellen.
 *
 * In GTM vangt één GA4-tag met eventnaam {{Event}} alle dga_menu_* en
 * dga_search_* events op (ingericht door Tomahawk, okt 2026). menu_url gaat
 * daar mee als link_url.
 */
(function () {
  'use strict';

  var MAX = 90;
  var crumbs = [];

  function clean(t) {
    return (t || '').replace(/\s+/g, ' ').trim().slice(0, MAX);
  }

  function labelOf(el) {
    if (!el) return '';
    var c = el.cloneNode(true);
    Array.prototype.forEach.call(c.querySelectorAll('svg'), function (s) { s.remove(); });
    return clean(c.textContent) || clean(el.getAttribute('aria-label'));
  }

  function localeOf() {
    try {
      if (window.Shopify && window.Shopify.locale) return window.Shopify.locale;
    } catch (e) {}
    return /^\/de(\/|$)/.test(location.pathname) ? 'de' : 'nl';
  }

  function consentAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed();
      }
    } catch (e) {}
    return true;
  }

  function send(name, params) {
    params = params || {};
    var payload = { event: name };
    for (var k in params) {
      if (Object.prototype.hasOwnProperty.call(params, k) && params[k] != null && params[k] !== '') {
        payload[k] = params[k];
      }
    }

    // Altijd pushen: consent wordt op één plek afgedwongen, in GTM (advanced
    // consent mode). Zonder toestemming stuurt GTM een cookieless ping, net als
    // bij alle andere events op de site.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    // Clarity loopt buiten GTM om en valt dus niet onder die consent mode,
    // daarom hier wel een eigen check.
    if (consentAllowed() && typeof window.clarity === 'function') {
      try {
        window.clarity('event', name);
        for (var t in params) {
          if (Object.prototype.hasOwnProperty.call(params, t) && params[t] != null && params[t] !== '') {
            window.clarity('set', t, String(params[t]));
          }
        }
      } catch (e) {}
    }
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || t.nodeType !== 1 || !t.closest) return;

    // terugknop op mobiel
    var back = t.closest('[data-dga-mob-back]');
    if (back) {
      send('dga_menu_back', {
        menu_device: 'mobile',
        menu_locale: localeOf(),
        menu_item: crumbs.length ? crumbs[crumbs.length - 1] : 'terug',
        menu_panel: crumbs.length > 1 ? crumbs[crumbs.length - 2] : 'root',
        menu_level: crumbs.length,
        menu_path: crumbs.join(' > ')
      });
      crumbs.pop();
      return;
    }

    // doorklikken naar een subpaneel op mobiel
    var go = t.closest('[data-dga-mob-go]');
    if (go) {
      var gl = labelOf(go);
      crumbs.push(gl);
      send('dga_menu_panel_open', {
        menu_device: 'mobile',
        menu_locale: localeOf(),
        menu_panel: gl,
        menu_item: gl,
        menu_level: crumbs.length,
        menu_path: crumbs.join(' > ')
      });
      return;
    }

    // paneel openklappen op desktop
    var trig = t.closest('.dga-mm__trigger');
    if (trig) {
      if (trig.getAttribute('aria-expanded') !== 'true') {
        send('dga_menu_panel_open', {
          menu_device: 'desktop',
          menu_locale: localeOf(),
          menu_panel: labelOf(trig),
          menu_item: labelOf(trig),
          menu_level: 1
        });
      }
      return;
    }

    // zoeksuggestie: deze sessies raken /search nooit aan
    var sugg = t.closest('[data-predictive-search] a[href], predictive-search a[href]');
    if (sugg) {
      // zoekterm en groep (direct, automaten, onderdelen, collecties, service, snel_naar)
      // uit de nieuwe zoekdropdown; vervangt het losse dga_search_click-event (geen dubbeltelling)
      var ps = sugg.closest('predictive-search');
      var inp = ps && ps.querySelector('input[type="search"]');
      var grp = sugg.closest('[data-dga-group]');
      send('dga_search_suggestion_click', {
        menu_device: window.matchMedia('(max-width: 989px)').matches ? 'mobile' : 'desktop',
        menu_locale: localeOf(),
        menu_item: labelOf(sugg.querySelector('.dga-ps__ptitle, .dga-ps__direct-label') || sugg),
        menu_url: sugg.getAttribute('href'),
        search_term: inp ? clean(inp.value) : null,
        search_group: grp ? grp.getAttribute('data-dga-group') : null
      });
      return;
    }

    // zoekfunctie openen
    if (t.closest('.search__button, .header__icon--search, details[id*="Search"] > summary')) {
      send('dga_search_open', {
        menu_device: window.matchMedia('(max-width: 989px)').matches ? 'mobile' : 'desktop',
        menu_locale: localeOf()
      });
    }
  }, true);

  // mobiel menu openen: de thema-drawer (<details>) krijgt het open-attribuut.
  // Niet op [data-dga-mob] letten: dga-mega-menu.js haalt daar hidden al bij het laden weg (fix 22-10-2026).
  function watchMobile() {
    var mob = document.getElementById('Details-menu-drawer-container');
    if (!mob) return;
    var was = mob.hasAttribute('open');
    new MutationObserver(function () {
      var now = mob.hasAttribute('open');
      if (now && !was) {
        crumbs = [];
        send('dga_menu_open', { menu_device: 'mobile', menu_locale: localeOf() });
      }
      if (!now && was) crumbs = [];
      was = now;
    }).observe(mob, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchMobile);
  } else {
    watchMobile();
  }
})();
